import './Projects.css';
import Grease from "../../assets/grease.png";
import Bubba from "../../assets/bubba.png";

function Projects() {
return (
    <div className="App main">
        <div className="resume">
            <div className="site-banner-header">
                <h1 className="resume">
                Projects
                </h1>
            </div>
            <div class="columns is-desktop">
                <div class="column">
                <div className="project-container">
                <a href="https://cristenrh.github.io/grease/">
                            <div className="grease">
                                </div>
                                </a>
                                  <div className="content">
                                        <h4>Grease: School Edition Playbill</h4>
                                        <p>
                                        An online playbill for Westwood High School's upcoming production of 'Grease:
                                        The School Edition'.
                                        </p>
                                        <ul>
                                        <li>
                                            React App
                                        </li>
                                        <li>
                                            Web Design
                                        </li>
                                        </ul>
                                    </div>
                               
                            </div>
                            </div>
            <div class="column"> 
            <div className="project-container">
            <a href="http://www.bubbacoltrane.com">
            <div className="bubba" >
                </div>
                </a>
                <div className="content">
                     <h4>Bubba Coltrane</h4>
                        <p>
                        Marketing Web Site for local Austin Band 'Bubba Coltrane and the Trainwrecks'
                        Includes Spotify Playlist, YouTube Videos and Upcoming Events.
                        </p>
                        <ul>
                            <li>
                                React App
                            </li>
                            <li>
                                Web Design
                            </li>
                        </ul>
                    </div>

                        </div>

                    </div>

</div>
    </div>
    </div>
        
    );
  }
  
  export default Projects;
  